import type { AnalyticsEvent } from '@rover/types/src/Analytics';
import fireDataLayerEvent from '@rover/utilities/fireDataLayerEvent';

import analyticsEventToDataLayerEvent from './analyticsEventToDataLayerEvent';

// Fire-and-forget, matching every existing caller's expectations: many pass this
// directly as a concise-arrow onClick/onPress handler, and Kibble's Button/Link
// await such a handler's return value before following href. Keep this one void so
// that behavior is untouched; use emitAnalyticsEventAndWait below where the event
// must reach GTM before navigation happens.
const emitAnalyticsEvent = (analyticsEvent: AnalyticsEvent): void => {
  const dataLayerEvent = analyticsEventToDataLayerEvent(analyticsEvent);

  fireDataLayerEvent(dataLayerEvent);
};

// The returned promise resolves once GTM has taken the event, or after
// fireDataLayerEvent's failsafe timeout. Await it before navigating away; the
// underlying dataLayer.push is deferred to a later tick and is lost if the page
// tears down first.
export const emitAnalyticsEventAndWait = (analyticsEvent: AnalyticsEvent): Promise<void> => {
  const dataLayerEvent = analyticsEventToDataLayerEvent(analyticsEvent);

  return fireDataLayerEvent(dataLayerEvent);
};

export default emitAnalyticsEvent;
